export var ACTIVE = 1;
export var WON = 2;
export var LOST = 3;
export var REFUND = 4;
export var SOLD = 5;
export var FACTOR_REFUND = 10;



// WEBPACK FOOTER //
// ./src/constants/FactorStatus.js